import HomeWorkIndex from '@/views/home-work/Index'
import WorkList from '@/views/home-work/work/WorkList'
import UploadView from '@/views/home-work/work/UploadView'

export default {
  path: '/home-work',
  component: HomeWorkIndex,
  redirect: '/home-work/list',
  name: 'HomeWork',
  meta: {
    title: '作业',
    icon: 'base-info2'
  },
  children: [
    {
      path: 'list',
      name: 'workList',
      component: WorkList,
      meta: {
        title: '作业列表',
        topMenu: '作业'
      }
    },
    {
      path: 'upload-view/:taskId',
      name: 'UploadView',
      component: UploadView,
      meta: {
        title: '上传状态'
      }
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/home-work.js